export interface CloudPointer {
  x: number;
  y: number;
  movedAt: number;
  speed: number;
  stroke: number;
  active: boolean;
}

export const cloudPointer: CloudPointer = {
  x: 0.5,
  y: 0.5,
  movedAt: 0,
  speed: 0,
  stroke: 0,
  active: false,
};

export const updateCloudPointer = (pointer: CloudPointer): void => {
  Object.assign(cloudPointer, pointer);
};

export const cloudPointerMotion = (
  pointer: CloudPointer,
  now: number
): number => {
  if (!pointer.active || pointer.movedAt === 0) return 0;
  return Math.exp(-Math.max(0, now - pointer.movedAt - 50) / 180);
};
